import React from 'react';
import withIcon from '../utilities/withIcon';

const IconThumbsUpFilled = () => {
  return (
    <g>
      <path d="m3.1267 5.8447h-2.288a.7.7 0 0 0 -.7.7v7.2253a.7.7 0 0 0 .7.7h2.288a.7.7 0 0 0 .7-.7v-7.2251a.7.7 0 0 0 -.7-.7002z" />
      <path d="m15.8615 6.8935a1.2052 1.2052 0 0 0 -1.2015-1.2017v-.0006h-5.0846a7.8507 7.8507 0 0 0 .5546-2.3419c.0334-.8345-.2845-1.9677-1.2861-2.0212-1.3154-.07-1.1233 1.8988-1.6292 2.6971a6.95 6.95 0 0 1 -2.3737 2.0164v8.17a4.3175 4.3175 0 0 0 1.6992.4622h6.5631a1.08 1.08 0 0 0 0-2.1565l.8259-.0006a1.0864 1.0864 0 0 0 0-2.1719l.2027-.0006a1.125 1.125 0 1 0 0-2.249h.528a1.2052 1.2052 0 0 0 1.2016-1.2017z" />
    </g>
  );
};

export default withIcon(IconThumbsUpFilled);
